import React, { Component } from 'react';
import MetricsResult from './MetricsResult';

function getQueryKey(query) {
  const { viz, ...rest } = query.kmetrics;
  return JSON.stringify(rest);
}

export default class MetricsExplorerResult extends Component {
  state = {
    loading: false,
    hash: '',
    queryKey: '',
    key: ''
  };

  static getDerivedStateFromProps(props, state) {
    const { hash, query } = props;
    const queryKey = getQueryKey(query);
    const hashChanged = !hash || hash !== state.hash;
    const queryKeyChanged = queryKey !== state.queryKey;

    if (queryKeyChanged && !hashChanged) {
      // wait for hash to change before updating the key
      return { loading: true };
    }

    if (queryKeyChanged && hashChanged) {
      // don't update the key if only the viz has changed
      return { loading: false, hash, queryKey, key: queryKey };
    }

    return null;
  }

  render() {
    const { loading: loadingProp } = this.props;
    const { loading, key } = this.state;
    return <MetricsResult {...this.props} loading={loadingProp || loading} key={key} />;
  }
}
